export default {"src":"/_next/static/media/Arrow-Right.0704f1f1.svg","height":24,"width":24};